import { SDLUtil, RequestUtil, StringUtil, DateUtil } from '@/utils';

const setMessage = ({ commit }, data) => {
  commit('SET_MESSAGE', data);
};

const increaseCnt = ({ commit }) => {
  commit('CHANGE_COUNT', 1);
};

const setGridData = ({ commit }, data) => {
  commit('SET_GRID_DATA', data);
};

const setTempData = ({ commit }, data) => {
  commit('SET_TEMP_DATA', data);
};
const setAdUserInfoData = ({ commit }, data) => {
  commit('SET_AD_USER_INFO_DATA', data);
};
export default {
  async CLICK_GET_BUTTON(store, param) {
    const message = await RequestUtil.get(`${SDLUtil.API_URL}/test/msg?code=` + param);

    setMessage(store, message);
    increaseCnt(store);
  },

  async CLICK_POST_BUTTON(store, param) {
    const message = await RequestUtil.post(`${SDLUtil.API_URL}/test/msg`, param);

    setMessage(store, message);
    increaseCnt(store);
  },

  async SEARCH_GRID(store, param) {
    const searchPeriod = DateUtil.stdFormat(param.searchPeriod);
    param = { ...param, ...searchPeriod };
    const data = await RequestUtil.get(`${SDLUtil.API_URL}/sample/pageList?${StringUtil.queryStringfy(param)}`);

    setGridData(store, data.data);
  },
  async INSERT_TEMP(store, param) {
    const data = await RequestUtil.post(`${SDLUtil.API_URL}/sample/temp`, param);
    setTempData(store, data.data);
  },
  async SEARCH_TEMP(store, param) {
    const data = await RequestUtil.get(`${SDLUtil.API_URL}/sample/temp/${param.tempId}`);
    setTempData(store, data.data);
  },
  async UPDATE_TEMP(store, param) {
    await RequestUtil.put(`${SDLUtil.API_URL}/sample/temp/${param.tempId}`, param);
  },
  async DELETE_TEMP(store, param) {
    await RequestUtil.delete(`${SDLUtil.API_URL}/sample/temp/${param.tempId}`);

    setTempData(store, {});
  },
  async SEARCH_AD_USER_INFO(store, param) {
    const data = await RequestUtil.get(`${SDLUtil.API_URL}/ad/user-info?${StringUtil.queryStringfy(param)}`);
    setAdUserInfoData(store, data.data);
  },
  async RELAY_CONNECTION_TEST(store) {
    const data = await RequestUtil.get(`${SDLUtil.API_URL}/ad/relay-connection-test`);
    setMessage(store, data.data);
  },
  async INIT_CF_USER(store) {
    const data = await RequestUtil.get(`${SDLUtil.API_URL}/ad/init-cf-user`);
    setMessage(store, data.data);
  },
};



// WEBPACK FOOTER //
// ./src/vuex/sample/samplePage/samplePageAction.js